import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50 relative overflow-hidden">
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
          Acesse o Melhor CSSBuy Spreadsheet
        </h2>
        <p className="text-lg md:text-xl text-foreground-600 mb-10 max-w-2xl mx-auto">
          Atualizado diariamente com os produtos mais procurados. Encontre sneakers, streetwear e muito mais com os melhores preços.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full bg-foreground-900 text-background-50 font-bold text-base hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap group"
        >
          Acessar CSSBuy Sheet Agora
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>

        <div className="mt-16 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">+500</p>
            <p className="text-sm text-foreground-500 mt-1">Produtos Atualizados</p>
          </div>
          <div className="w-px h-10 bg-background-300 hidden md:block"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-accent-500">Diário</p>
            <p className="text-sm text-foreground-500 mt-1">Atualizações</p>
          </div>
          <div className="w-px h-10 bg-background-300 hidden md:block"></div>
          <div className="text-center">
            <p className="font-heading text-3xl md:text-4xl font-bold text-secondary-500">14</p>
            <p className="text-sm text-foreground-500 mt-1">Categorias</p>
          </div>
        </div>
      </div>
    </section>
  );
}